export default "__VITE_ASSET__BPyzXhlG__"